module.exports = __webpack_public_path__ + "static/media/redpacket-sm.0dc94fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/redpacket-sm.png
// module id = 1986
// module chunks = 4